export enum ResultConstant {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  ABORTED = 'ABORTED',
  NOT_EXECUTED = 'NOT_EXECUTED',
  QUEUED = 'QUEUED',
  STOPPED = 'STOPPED',
}
